import { connect } from 'react-redux';

import { modal as modalActions } from './../actions';
import {
  getMetricsPageInfo,
  getScenariosByDispatcherId,
  getMetricsPageType,
} from './../reducers';
import { pageTypes as pageTypeHelpers } from './../helpers';
import {
  metrics as metricSelectors,
  metricsPage as metricPageSelectors
} from '../selectors';

import ViewScenarioStatusComponent from './../Components/ViewScenarioStatusComponent.jsx';

export const mapStateToProps = (state) => {
  const metricsInfo = getMetricsPageInfo(state);
  const pageType = getMetricsPageType(state);

  const scenarios = getScenariosByDispatcherId(state, metricsInfo.dispatcherId) || [];
  const scenariosByName = scenarios.reduce(
    (obj, scenario) => (obj[scenario.name.toLowerCase()] = scenario, obj),
    {}
  );

  let scenario = {};
  let status = {};
  if (pageType === pageTypeHelpers.EXPORTTESTS)
  {
    scenario = scenariosByName[metricsInfo.snPartI + '-' +
      metricsInfo.snPartII + '-' + metricsInfo.snPartIII];
    status.status = scenario ? scenario.status : '';
  }
  else if (pageType === pageTypeHelpers.CASEAMENDINGTESTS)
  {
    scenario = scenariosByName[metricsInfo.snPartI + '-' + metricsInfo.snPartII];
    status.status = scenario ? scenario.status : '';
  }
  else if (pageType === pageTypeHelpers.CASEAMENDINGKPPTESTS)
  {
    scenario = scenariosByName[metricsInfo.snPartII];
    status.status = scenario ? scenario.status : '';
  }
  else if (pageType === pageTypeHelpers.PERFORMANCEMETRICS)
  {
    const scenarioStatusByCaseAction =
      metricSelectors.caseActionsScenarioStatusByDispatcher(state);
    status.status = scenarioStatusByCaseAction[metricsInfo.caseName +
        '|' + metricsInfo.action];
  }
  else
  {
    // STS-2301 related
    // temporary check for diff results here to overcome and Jenkins job monitor issue
    // once complete can revert to relying on stored scenario status
    scenario = scenariosByName[metricsInfo.image] || {};
    status = metricPageSelectors
      .getAnalyzedMetricRunnerStatus(state, scenario.runner);
  }

  return {
    dispatcherId: metricsInfo.dispatcherId,
    verdictReason: status && status.message,
    verdictStatus: status && status.status,
    scenarioReason: scenario && scenario.reason,
    scenarioStatus: scenario && scenario.status
  };
};

export const mapDispatchToProps = (dispatch) => ({
  onStatusClick: (dispatcherId) =>
    dispatch(modalActions.showScenarioModal(true, dispatcherId))
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewScenarioStatusComponent);


// WEBPACK FOOTER //
// src/Containers/ViewScenarioStatusContainer.jsx